import { TFunction } from 'react-i18next';
import { SparseReportingQuery } from '@flexible-reports/store/api/templates/types';

export const MAX_RECURRING_SUBSCRIPTION_LIMIT = 80;

export interface CreateReportButtonStatusProps extends UseCreateReportButtonProps {
  readonly translate: TFunction;
  readonly isSaving: boolean;
  readonly maxRecurringLimitError: boolean;
}

export interface UseCreateReportButtonProps {
  showError: boolean;
  originalTemplateQuery?: SparseReportingQuery | null;
}

export interface CreateApiSuccessResponse {
  readonly reportConfigurationId?: string;
  readonly latestScheduledReportId?: string;
}

export interface CreateApiErrorResponse {
  readonly status: number;
  readonly errorCode: string;
  readonly message: string;
}
